<template>
    <div>
        <ts-loading-banner :loading="loading">
            <div class="ts-space-y-2">
                <div class="row">
                    <div class="col-md-12">
                        <ProductInfo v-model="model" :validate="errors" @loading="value => (loading = value)" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <ProSaleCodeList v-model="model" :validate="errors" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 ts-mt-3 ts-text-right">
                        <ts-button class="ts-mr-2" @click.prevent="() => $emit('cancel')">
                            {{ $t("cancel") }}
                        </ts-button>
                        <ts-button color="primary" @click.prevent="onSave" :waiting="loading">
                            {{ $t("save") }}
                        </ts-button>
                    </div>
                </div>
            </div>
        </ts-loading-banner>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { includes } from "lodash";
import { isEmpty } from "lodash";
import { debounce } from "lodash";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import ProductInfo from './component-products/product-info.vue'
import ProSaleCodeList from './component-products/pro-sale-code-list.vue'

export default {
    name: "form",
    components: {
        ProductInfo,
        ProSaleCodeList,
    },
    data() {
        return {
            loading: false,
            employee_loading: false,
            errors: new Errors(),
            model: {
                product_id: 0,
                category_id: null,
                product_name_kh: null,
                product_name_en: null,
                barcode: null,
                uom_cat_id: null,
                product_type_id: 2,
                pro_group_id: null,
                product_mode_id: 1,
                age_eligible_from: null,
                age_eligible_to: null,
                minimum_reorder_qty: null,
                maximum_reorder_allow: null,
                is_expirable: false,
                is_feature: false,
                vat_eligible: false,
                is_generate_unique_serial: false,
                photo: null,
                product_sale_code: [],
                other_branch_list: [],
                vendor_list: [],
                recipes: [],
                account_id: undefined,
                require_imei: false,
                is_warranty: false,
            }
        };
    },
    created() {
        this.fetchResources();
    },
    computed: {
        ...mapState("customerService/serviceTicket", ["formViewDatas", 'edit_data']),
        employees() {
            if (this.formViewDatas.employees) {
                return this.formViewDatas.employees
                    .map(el => ({
                        value: el.employee_id,
                        label: el.employee_name_en
                    }))
            }
            return []
        },
        serviceTicketStatus() {
            if (this.formViewDatas.serviceTicketStatus) {
                if (includes([1, 2], this.model.ticket_status_id)) {
                    return this.formViewDatas.serviceTicketStatus
                        .filter(el => includes([1, 2], el.ticket_status_id))
                        .map(el => ({
                            value: el.ticket_status_id,
                            label: el.ticket_status
                        }));
                }
                if (includes([9, 10], this.model.ticket_status_id)) {
                    return this.formViewDatas.serviceTicketStatus
                        .filter(el => includes([9, 10], el.ticket_status_id))
                        .map(el => ({
                            value: el.ticket_status_id,
                            label: el.ticket_status
                        }));
                }
                return this.formViewDatas.serviceTicketStatus
                    .map(el => ({
                        value: el.ticket_status_id,
                        label: el.ticket_status
                    }));
            }
            return [];
        },
    },
    methods: {
        ...mapActions("customerService/serviceTicket", ["getFormViewModel"]),
        ...mapActions('product/profile', ['fetchBefore', 'store', 'upload', 'formViewModel']),
        handleSearchEmployee: debounce(function (value) {
            this.employee_loading = true;
            this.getFormViewModel({
                index: "employees",
                params: {
                    fnName: "employees",
                    search: value
                }
            }).finally(() => (this.employee_loading = false));
        }, 800),
        onChangeTicketOwner(value) {
            if (value) {
                this.model.ticket_status_id = 2
            } else {
                this.model.ticket_status_id = 1
            }
        },
        onChangeTicketStatus(value) {
            if (value == 1) {
                this.model.ticket_owner = null;
            }
        },
        fetchResources() {
            this.loading = true;
            this.fetchBefore()
                // .then(() => {
                //     this.setEditData();
                // })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async onSave() {
            this.loading = true;
            this.$store
                .dispatch("product/profile/store", this.model)
                .then(async response => {
                    await this.$store
                        .dispatch("product/profile/find", response.product_id)
                        .then(() => {
                            let edit_data = this.$store.state.product.profile.edit_data

                            this.formViewDatas.products.push({
                                barcode: edit_data.barcode,
                                loading_sale: edit_data.loading_sale,
                                loading_stock: edit_data.loading_stock,
                                product_id: edit_data.product_id,
                                product_name_en: edit_data.product_name_en,
                                product_name_kh: edit_data.product_name_kh,
                                uom_cat_id: edit_data.uom_cat_id,
                                uom_category: edit_data.uom_category,
                            })

                            this.$emit('setProduct', edit_data)
                            this.$store.state.product.profile.edit_data = {}
                            this.$emit('cancel');
                        })

                    this.notice({
                        type: "success",
                        text: response.message
                    });
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                let ticket_status_id = this.edit_data.ticket_status_id;

                switch (this.edit_data.ticket_status_id) {
                    case 1:
                        ticket_status_id = 2;
                        break;
                    case 3:
                        ticket_status_id = 3;
                        break;
                    case 6:
                        ticket_status_id = 7;
                        break;
                    case 9:
                        ticket_status_id = 10;
                        this.model.end_date = moment().format('DD-MM-YYYY HH:mm:ss');
                        break;
                    default:
                        ticket_status_id = this.edit_data.ticket_status_id;
                        break;
                }

                this.model.service_ticket_id = this.edit_data.service_ticket_id;
                this.model.ticket_status_id = ticket_status_id;
                this.model.ticket_owner = this.edit_data.ticket_owner;
            }
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "SERVICE TICKET",
                desc: not.text
            });
        }
    },
    watch: {}
};
</script>